import { render } from "./WorkFormInformations.vue?vue&type=template&id=2e8d0ef4"
import script from "./WorkFormInformations.vue?vue&type=script&lang=js"
export * from "./WorkFormInformations.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__